/**
 * 유물 정의 (relics.tsv) — relicId별 등급·심볼·효과(effectType+effectValue)·획득 비용.
 * 수치는 TSV에서 수정 후 `npm run export:data`.
 */
import relicsJson from "../generated/relics.json";
import type { ModuleRarity } from "../../modules/ProjectileModule.js";
import type { RelicDef, RelicEffectType } from "../../models/RelicEffect.js";

/**
 * 유물 정의 (relics.tsv). relicId별 등급·심볼·효과(effectType+effectValue)·획득 비용.
 * 효과 적용은 RelicController + GameScene 4지점 (effectType별 +% 곱연산, 동일 type 합산).
 * enable=false 행은 제외 (유물 탭 미노출). drops/statUpgrades와 동일한 Object.fromEntries(json.map) 패턴.
 */
export const RELIC_DEFS: Record<string, RelicDef> = Object.fromEntries(
  relicsJson
    .filter((r) => r.enable)
    .map((r) => [
      r.relicId,
      {
        relicId: r.relicId,
        grade: r.grade as ModuleRarity,
        symbol: r.symbol,
        effectType: r.effectType as RelicEffectType,
        base: r.base,
        effectExpr: r.effectExpr,
        cost: r.cost,
        order: r.order,
      } satisfies RelicDef,
    ]),
);

/** order 순 정렬된 유물 정의 목록 (UI 카드 그리드 + 전체 순회용). */
export const RELIC_DEFS_ORDERED: readonly RelicDef[] = Object.values(RELIC_DEFS).sort(
  (a, b) => a.order - b.order,
);
